import { Autocomplete } from '@base-ui/react/autocomplete';
import type { ComponentProps } from 'react';

import { getProductResultUrl, getSearchResultUrl } from '../../../lib';
import type { PrimaryResultItem, SearchResultItem } from '../../../search.types';
import { ProductResult } from './product-result';
import { SuggestionResult } from './suggestion-result';

type SearchResultLinkClickHandler = NonNullable<ComponentProps<typeof Autocomplete.Item>['onClick']>;

type SearchResultLinkProps = {
    onResult: (result: SearchResultItem) => void;
    query: string;
    result: PrimaryResultItem;
};

export function SearchResultLink({ onResult, query, result }: Readonly<SearchResultLinkProps>) {
    const { item } = result;
    const isProduct = item.kind === 'product';
    const href = isProduct ? getProductResultUrl(item, query) : getSearchResultUrl(item, query);

    const handleClick: SearchResultLinkClickHandler = event => {
        const keepNativeNavigation =
            event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;

        event.preventBaseUIHandler();
        if (keepNativeNavigation) return;

        event.preventDefault();
        onResult(result);
    };

    return (
        <Autocomplete.Item className="header-search__cell" onClick={handleClick} value={result}>
            <a className="header-search__item" href={href} tabIndex={-1}>
                {isProduct ? <ProductResult product={item} /> : <SuggestionResult item={item} />}
            </a>
        </Autocomplete.Item>
    );
}
